import React from "react";
import QuestionsBox from "../QuestionInstructions/QuestionsBox";
import marker from "../../../src/assests/images/marker_black.svg";
import { useTaskContext } from "../store/AlltasksContext";
import Notes from "../QuestionInstructions/Notes";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
// import {  } from "../QuestionInstructions/VisibilityProvider";
import ImageUploadTask from "../FileuploadWithPreview/ImageUploadTask";

// const TargetQuestions: React.FC = () => {
  interface TargetQuestionsProps {
    lang: {
      imgageGifVideo: string;
      uploadImage: string;
      pageLabel: string;
      uploadText: string;
      uploadSize: string;
      addMore: string;
      instruction: string;
      addInstruction: string;
      option: string;
      questionPoint: string;
      addOptions: string,
      selectCorrectOptionHint: string,
      writeHintCorrectOption: string,
  
  
    };
  }
  const TargetQuestions: React.FC<TargetQuestionsProps> = ({ lang }) => {
  const { showNoTask, targetData, settargetData, showImageUploadBanner } =
    useTaskContext(); // const { showImageUploadBanner } = useVisibilityContext();

  const handleNameChange = (name: string) => {
    console.log(`Name changed to ${name}`);
  };

  const handleDeleteSection = (id: number) => {
    settargetData((prevData) =>
      prevData.filter((section) => section.id !== id)
    );
  };

  const gridData = [
    {
      id: 1,
      title: "Notes",
      placeholderPrefix: "Write a note if required",
      notes: [{ id: 1, value: "" }],
    },
  ];

  return (
    <div>
      <QuestionsBox
        sectionsData={targetData}
        setSectionsData={settargetData}
        seteducationalData={settargetData}
        educationalData={targetData}
        onDeleteSection={handleDeleteSection}
      
        combinedqtnclass={"targetqtnbox"} lang={lang}     />
      {showNoTask && (
        <Notes gridData={gridData} trashIcon={trash} plusIcon={plus} />
      )}
      {showImageUploadBanner && (
        <ImageUploadTask
        sectionTitle={lang.imgageGifVideo}
          placeholder="Your Name"
          pageLabel={lang.pageLabel}
          bannerProps={{
            title: lang.uploadImage,
            uploadText: lang.uploadText,
            uploadSize: lang.uploadSize,
            imageUrls: "",
            maintitle:"",
            setuploadedImage: (image) => console.log(`Uploaded image: ${image}`),
          }}
          lang={lang}
          instructions={[{ id: 1, value: "",image:"",smallimage: "", bigimage: ""}]}
          markerImage={marker}
          onNameChange={handleNameChange}
          trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
            throw new Error("Function not implemented.");
          } }        />
      )}
    </div>
  );
};

export default TargetQuestions;